import { render, staticRenderFns } from "./HenkilotTable.vue?vue&type=template&id=2170cb2d"
import script from "./HenkilotTable.vue?vue&type=script&lang=js"
export * from "./HenkilotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports